import React from 'react'
// import Footer from './Footer'
import Landing from './Landing'
import Load from './Load'
import Menu from './Menu'
import Nav from './Nav'
import About from './About'
// import Projects from './Projects'
import { Redirect, Route, Switch } from "react-router-dom";
import AboutFull from './AboutFull'


export default function Main() {

    const LandingPage = () => {
        return (
            <div>
                <Landing />
                <About />
                <Menu />
            </div>
        )
    }

    const AboutFullPage = () => {
        return (
            <AboutFull />
        )
    }

    return (
        <div>
            <Load />
            <Nav />
            <Switch>
                <Route path="/home" >
                    {LandingPage}
                </Route>
                <Route path="/about" >
                    {AboutFullPage}
                </Route>
                <Redirect to="/home" />
            </Switch>
        </div>
    )
}
